import { useOnFunctionCalled } from 'navigation-components/consumer/hooks';
import { useEffect } from 'react';
import { getPrimaryTabUtil } from '../utils/PrimaryTabUtil';
/**
 * Opt into receiving primary tab status updates from the host for this component definition
 */
const usePrimaryTabTracker = componentDef => {
  const {
    registerCallback
  } = useOnFunctionCalled(componentDef);
  useEffect(() => {
    return registerCallback('onPrimaryTabChange', onPrimaryTabArgs => {
      assertIsOnPrimaryTabChangeArgs(onPrimaryTabArgs);
      getPrimaryTabUtil().setIsPrimary(onPrimaryTabArgs.isPrimaryTab);
    });
  }, [registerCallback]);
};
function assertIsOnPrimaryTabChangeArgs(argsMaybe) {
  if (typeof argsMaybe !== 'object' || typeof argsMaybe.isPrimaryTab !== 'boolean') {
    throw new Error('onPrimaryTabChange was called with unexpected arguments', argsMaybe);
  }
}
export default usePrimaryTabTracker;